import ApiError from "../../errors/ApiError";
import { LINK_CUSTOMER_KROSS_INVALID_CREDENTIALS_ERROR } from "./error-codes.constants";

export class LinkCustomerKrossInvalidCredentialsError extends ApiError {
  constructor() {
    super(LINK_CUSTOMER_KROSS_INVALID_CREDENTIALS_ERROR);
  }
}
